import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import showToast from "../../../services/toast";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
import PagesHeader from "ah_utility/PagesHeader";
export var PassengerFormHeader = function (props) {
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: props.loading, seeToast: props.seeToast, showToast: showToast, setSeeToast: props.setSeeToast, titleLoading: "Cargando..." }), _jsx(PagesHeader, { titlePage: "Agregar Pasajero", hideStep: true, steps: props.steps, completed: false })] }));
};
